import { i18n } from './i18n'
const JWT = require("jsonwebtoken");
const cookie = require('vue-cookies')
const AUTH_USER_COOKIE_KEY = 'malloc-auth-user'
const AUTH_USER_LOCALE_PREFERENCE = 'malloc-locale'
cookie.config('14d');

export default {
  /**
   * Get Locale
   * @returns {*|string}
   */
  getLocale: () => {
    let detectedBrowserLocale = window.navigator.userLanguage || window.navigator.language
    return cookie.get(AUTH_USER_LOCALE_PREFERENCE) || detectedBrowserLocale.substring(0, 2)
  },

  /**
   * Set Locale
   * @param locale
   * @returns {*}
   */
  setLocale: (locale) => {
    i18n.locale = locale
    return cookie.set(AUTH_USER_LOCALE_PREFERENCE, locale)
  },

  /**
   * Logout the user
   */
  removeAuthUser: () => {
    cookie.remove(AUTH_USER_COOKIE_KEY)
  },

  getJWT: () => {
    return cookie.get(AUTH_USER_COOKIE_KEY) || false;
  },

  getAuthUser: (jwt = false) => {
    if (jwt === false) {
      jwt = cookie.get(AUTH_USER_COOKIE_KEY) || false;
    }

    const now = new Date();
    const currentTimestamp = Math.floor(now/1000);

    if (jwt === false) {
      return {};
    }

    let authUser = JWT.decode(jwt);
    if (authUser['exp'] < currentTimestamp) {
      cookie.remove(AUTH_USER_COOKIE_KEY);
      return {};
    }

    cookie.set(AUTH_USER_COOKIE_KEY, jwt);
    return authUser;
  }
}